import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env } from '../../../app.constant';
import { AllotmentData, AllotmentQuarterForm, ApiResponse } from '../../data/system/allotment';

@Injectable()
export class AllotmentService extends AllotmentData {

  constructor(private http: HttpClient) { super(); }

  save(form: AllotmentQuarterForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.allotment_quarter_save}`;
    return this.http.post<ApiResponse>(host, form);
  }

  update(form: AllotmentQuarterForm | any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.allotment_quarter_update}`;
    return this.http.post<ApiResponse>(host, form);
  }

  getByAccountAndQuarter(params: any) {
    const host = `${env.host}${env.endpoint.allotment_quarter_get_by_account_quarter}`;
    return this.http.post<ApiResponse>(host, params);
  }

  delete(id: number) {
    const host = `${env.host}${env.endpoint.allotment_delete.replace("{id}", id)}`;
    return this.http.delete<ApiResponse>(host);
  }

}
